var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDesktopAccaGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 57H46.5C48.1575 57 49.5 58.3425 49.5 60C49.5 60.8287 48.8287 61.5 48 61.5H24C23.1712 61.5 22.5 60.8287 22.5 60C22.5 58.3425 23.8425 57 25.5 57Z",
    fill: "#239A6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 51H28.5V57H43.5V51Z",
    fill: "#239A6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 10.5H12C10.3431 10.5 9 11.8431 9 13.5V48C9 49.6569 10.3431 51 12 51H60C61.6568 51 63 49.6569 63 48V13.5C63 11.8431 61.6568 10.5 60 10.5Z",
    fill: "#43DAA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.405 35.4526C33.5282 35.4526 36.06 32.9207 36.06 29.7976C36.06 26.6744 33.5282 24.1426 30.405 24.1426C27.2818 24.1426 24.75 26.6744 24.75 29.7976C24.75 32.9207 27.2818 35.4526 30.405 35.4526Z",
    fill: "#CFFCEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0963 30.6914H32.7863C31.9578 30.6914 31.2863 31.363 31.2863 32.1914V40.5014C31.2863 41.3298 31.9578 42.0014 32.7863 42.0014H41.0963C41.9247 42.0014 42.5963 41.3298 42.5963 40.5014V32.1914C42.5963 31.363 41.9247 30.6914 41.0963 30.6914Z",
    fill: "#9EEED3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.92 25.3283L38.4412 19.6283C37.9425 19.2945 37.2712 19.6508 37.2712 20.2508V31.6508C37.2712 32.2508 37.9425 32.607 38.4412 32.2733L46.92 26.5733C47.3625 26.277 47.3625 25.6245 46.92 25.3283Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDesktopAccaGreen);
export default __webpack_public_path__ + "static/media/icon_desktop_acca_green.b074fe13.svg";
export { ForwardRef as ReactComponent };